import { useState, useEffect } from 'react';

const useInterval = (callback: () => void, delay: number, enabled = true) => {
    const [isRunning, setIsRunning] = useState(enabled);

    useEffect(() => {
        let intervalId: NodeJS.Timeout;

        if (isRunning) {
            intervalId = setInterval(callback, delay);
        }

        return () => clearInterval(intervalId);
    }, [isRunning, delay, callback]);

    const startInterval = () => {
        if (enabled) {
            setIsRunning(true);
        }
    };

    const stopInterval = () => {
        if (enabled) {
            setIsRunning(false);
        }
    };

    return { startInterval, stopInterval };
};

export default useInterval;
